// extracted by mini-css-extract-plugin
export default {"wrapper":"HelpCenterArticles_wrapper__kUcWo","header":"HelpCenterArticles_header__uANm6","content":"HelpCenterArticles_content__y-1U7"};